module.exports = __webpack_public_path__ + "static/media/scann-mobile.c32cc5cf.png";